<div class="evidence-table card-mode">
  <div class="evidence-table__toolbar">
    <span class="evidence-table__range">
      {{ labels.showing }} {{ rangeStart() }}–{{ rangeEnd() }} {{ labels.of }}
      {{ items().length }} {{ labels.documents }}
    </span>
  </div>

  <div class="evidence-table__scroll">
    <table class="evidence-table__table">
      <thead>
        <tr>
          <th scope="col">{{ labels.filename }}</th>
          <th scope="col">{{ labels.type }}</th>
          <th scope="col">{{ labels.comments }}</th>
          <th scope="col">{{ labels.uploadedAt }}</th>
        </tr>
      </thead>
      <tbody>
        @for (item of visible(); track item.item_id) {
          <tr>
            <td>
              <a
                class="evidence-table__open"
                rel="noopener noreferrer"
                target="_blank"
                [routerLink]="['/', token(), 'open', item.item_id]"
                [title]="labels.openTitle">
                <i aria-hidden="true" class="pi pi-external-link"></i>
                {{ item.filename }}
              </a>
            </td>
            <td>{{ fileType(item) }}</td>
            <td class="evidence-table__comments">{{ item.comments }}</td>
            <td>{{ item.uploaded_at | date: 'medium' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <nav class="evidence-table__pager" [attr.aria-label]="labels.page">
    <label class="evidence-table__page-size">
      <span>{{ labels.rowsPerPage }}</span>
      <select
        class="evidence-table__select"
        (change)="selectPageSize(+$any($event.target).value)">
        @for (size of pageSizes; track size) {
          <option [selected]="size === pageSize()" [value]="size">
            {{ size }}
          </option>
        }
      </select>
    </label>
    <button
      class="evidence-table__page-button"
      type="button"
      [attr.aria-label]="labels.previousPage"
      [disabled]="page() === 1"
      (click)="goToPage(page() - 1)">
      <i aria-hidden="true" class="pi pi-chevron-left"></i>
    </button>
    <span class="evidence-table__page-label">
      {{ labels.page }} {{ page() }} {{ labels.of }} {{ pageCount() }}
    </span>
    <button
      class="evidence-table__page-button"
      type="button"
      [attr.aria-label]="labels.nextPage"
      [disabled]="page() === pageCount()"
      (click)="goToPage(page() + 1)">
      <i aria-hidden="true" class="pi pi-chevron-right"></i>
    </button>
  </nav>
</div>
